export const LOAN_TAKE_BACK_MINIMUM_AMOUNT = 5;
